import {
  IconButton,
  InputAdornment,
  TextField,
  TextFieldProps,
} from '@material-ui/core'
import { ClearOutlined } from '@material-ui/icons'
import { AppSearchIcon } from 'components/Icons/AppSearchIcon'
import { isEmpty } from 'lodash'
import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

export const SearchTextField = (
  props: {
    onSearch: (search: string) => void
    timeout?: number
  } & TextFieldProps
) => {
  const { onSearch, ...textFieldProps } = props
  const { t } = useTranslation()

  const [search, setSearch] = useState('')

  const searchTimeout = useRef(undefined)

  const handleSearchChange = (value: string) => {
    clearTimeout(searchTimeout.current)

    setSearch(value)

    searchTimeout.current = setTimeout(() => {
      onSearch(isEmpty(value) ? undefined : value)
    }, props.timeout ?? 250)
  }

  return (
    <TextField
      {...textFieldProps}
      value={search}
      onChange={(e) => handleSearchChange(e.target.value)}
      placeholder={t('common:search', 'search')}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <AppSearchIcon />
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              disabled={search === ''}
              onClick={() => handleSearchChange('')}
              size="small"
              color="secondary"
            >
              <ClearOutlined fontSize="small" color="secondary" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}
